// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { powerCog16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-power-cog': IconPowerCog;
    }
}

/**
 * The icon component for the 'powerCog' icon
 */
export class IconPowerCog extends IconSvg {
    public constructor() {
        super(powerCog16X16);
    }
}

registerIconSvg('icon-power-cog', IconPowerCog);
export const iconPowerCogTag = 'nimble-icon-power-cog';
